import { Form, Input, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useRef, useState } from "react";
import rpmService from "../../../../Services/rpmService";
import { convertUTCDate } from "../../../../utils/convertionFunc";
import { useDispatch } from "react-redux";
import { fetchRpmDevicesList } from "../../../../Redux/actions/rpmActions";

function NewDeviceSetUp({ handleCloseModal }) {
  const [loader, setLoader] = useState(false);
  const formRef = useRef();
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { brand, code, description, model, name, serialNumber } =
      formRef.current.getFieldValue();

    if (!code || !name || !brand || !model || !serialNumber) {
      message.error("Please fill in all required fields");
      return;
    }
    setLoader(true);
    const payload = {
      brand,
      code,
      createdBy: loggedUser?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      description,
      devicesCreatedBy: loggedUser?.user?.userId,
      model,
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      name,
      serialNumber,
      status: 1,
      // fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      // toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss")
    };

    try {
      await rpmService.newDeviceSave(payload);
      setLoader(false);
      handleCloseModal();
      dispatch(fetchRpmDevicesList({ status: 1 }));
    } catch (e) {
      setLoader(false);
      console.error(e);
    }
  };

  return (
    <>
      <Form ref={formRef} layout="vertical">
        <div className="grid grid-cols-2 items-center gap-4">
          <div>
            <Form.Item
              label={
                <span>
                  Code <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="code"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Name <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="name"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Brand <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="brand"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Model <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="model"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Serial Number <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="serialNumber"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Description
                  {/* <span style={{ color: "#FF000F" }}>*</span> */}
                </span>
              }
              name="description"
            >
              <TextArea rows={4} placeholder="Enter" />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className="flex items-center w-full justify-end my-5">
        <button
          onClick={handleCloseModal}
          className="border-brand-primaryColor border rounded tect-black bg-white text-sm px-6 py-1.5"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={loader}
          className="bg-brand-primaryColor text-white border-brand-primaryColor border rounded px-5 py-1.5 text-brand-textWhite text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default NewDeviceSetUp;
